module.exports = __webpack_public_path__ + "img/dio_pc_ewm.99abd861.png";